/**
 * Current payment method on a BAN (from getCustomerPaymentsData → paymentData)
 */
/**
 * @param {string|number} raw
 * @returns {typeof BanPaymentDataType[keyof typeof BanPaymentDataType]|null}
 */
export const BanPaymentDataType = {
  CREDIT_CARD: 'CREDIT_CARD',
  BANK: 'BANK',
  DIFFERENT: 'DIFFERENT',
  PAYPAL: 'PAYPAL',
  UNKNOW: 'UNKNOW',
};

export const normalizeBanPaymentDataType = (raw) => {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim().toUpperCase().replace(/[\s-]/g, '_');

  if (s === 'CREDIT_CARD') {
    return BanPaymentDataType.CREDIT_CARD;
  } else if (s === 'BANK') {
    return BanPaymentDataType.BANK;
  } else if (s === 'PAYPAL') {
    return BanPaymentDataType.PAYPAL;
  }

  return BanPaymentDataType.DIFFERENT;
};

export const mapPaymentDataFromBackend = (raw) => {
  if (!raw || typeof raw !== 'object') return null;
  const paymentType = normalizeBanPaymentDataType(raw.paymentType);
  if (!paymentType) return null;
  const fourNums = raw.fourNums != null ? String(raw.fourNums).trim() : null;
  const ppToken = raw.paypalToken != null ? String(raw.paypalToken).trim() : null;
  return {paymentType, fourNums: fourNums || null, paypalToken: ppToken || null};
};

/** Shared label + masked digits for a BAN payment method (credit card or bank). */
export const getBanPaymentMethodDisplayParts = (paymentData) => {
  const paymentType = paymentData?.paymentType;
  let label = 'אמצעי התשלום לא מעודכן';
  if (paymentType === BanPaymentDataType.CREDIT_CARD) {
    label = 'מחוייב בכרטיס אשראי';
  } else if (paymentType === BanPaymentDataType.BANK) {
    label = 'מחוייב בהוראת קבע';
  } else if (paymentType === BanPaymentDataType.PAYPAL) {
    label = 'מחוייב בפייפאל';
  }
  let masked = paymentData?.fourNums ? `${paymentData.fourNums} ****` : '';
  if (paymentType === BanPaymentDataType.PAYPAL) {
    masked = paymentData?.paypalToken ? `${paymentData.paypalToken}` : '';
  }
  return `${label} ${masked}`;
};

/**
 * Primary (purple) mini button only when there is no debt but payment method must be updated.
 * @param {{ hasDebt?: boolean, hasPaymentMethodIssue?: boolean }} ban
 */
export const isBanUpdatePaymentButtonPrimary = (ban) => {
  return !!(ban && !ban.hasDebt);
};

export const bankValidationErrorMessage = {
  7050: {
    title: 'אין התאמה בפרטי החשבון',
    subTitle: ` הפרטים שהוזנו אינם תואמים לבנק או לסניף.
        <br />
        יש לבדוק את הפרטים ולנסות שוב`,
  },
  703: {
    title: ` הוראת קבע זו משויכת<br /> למספר חשבונות מקסימלי`,
    subTitle: `יש להזין פרטי חשבון אחרים`,
  },
  704: {
    title: `לא ניתן לעדכן את<br /> אמצעי התשלום שנבחר`,
    subTitle: `יש לבחור אמצעי תשלום אחר`,
  },
  702: {
    title: `לא ניתן לעדכן את<br /> אמצעי התשלום שנבחר`,
    subTitle: `יש לבחור אמצעי תשלום אחר`,
  },
};
